var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4696_15027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.75 338.848C183.195 339.611 176.598 340 170 340C76.1118 340 0 263.888 0 170C0 76.1118 76.1118 0 170 0C263.888 0 340 76.1118 340 170C340 173.45 339.892 176.9 339.661 180.35C338.79 194.245 326.833 204.833 312.932 203.983C299.031 203.133 288.45 191.176 289.271 177.275C289.4 174.847 289.473 172.427 289.473 170C289.473 104.015 235.985 50.5275 170 50.5275C104.015 50.5275 50.5275 104.015 50.5275 170C50.5275 235.985 104.015 289.473 170 289.473C174.639 289.473 179.27 289.199 183.88 288.659C197.731 287.038 210.278 296.999 211.899 310.85C213.519 324.701 203.608 337.227 189.75 338.848Z",
    fill: "url(#paint0_linear_4696_15027)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4696_15027",
    x1: 22.897,
    y1: 416.759,
    x2: 317.103,
    y2: 235.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4696_15027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 340,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderOuter);
export default __webpack_public_path__ + "static/media/loaderOuter.9f86c669a1124ec9f19c53c094e3f595.svg";
export { ForwardRef as ReactComponent };